import React, { useState, useEffect } from 'react';
import ReactQuill from 'react-quill';
import { getFirestore, doc, getDoc, setDoc } from 'firebase/firestore';
import 'react-quill/dist/quill.snow.css';
import { Button, TextField, Typography, Stack } from '@mui/material';

const db = getFirestore();

export default function EmailTemplateEditor() {
  const [subject, setSubject] = useState('');
  const [htmlContent, setHtmlContent] = useState('');

  useEffect(() => {
    const fetchTemplate = async () => {
      try {
        const docRef = doc(db, 'emailTemplates', 'welcomeEmail');
        const snapshot = await getDoc(docRef);
        if (snapshot.exists()) {
          const data = snapshot.data();
          setSubject(data.subject || '');
          setHtmlContent(data.html || '');
        }
      } catch (err) {
        console.error('Error fetching welcome email template:', err);
      }
    };
    fetchTemplate();
  }, []);

  const handleSave = async () => {
    try {
      const docRef = doc(db, 'emailTemplates', 'welcomeEmail');
      await setDoc(docRef, { subject, html: htmlContent }, { merge: true });
      alert('Template saved successfully!');
    } catch (err) {
      console.error('Error saving template:', err);
      alert('Failed to save template.');
    }
  };

  return (
    <div>
      <Typography variant="h5" gutterBottom>
        Edit Welcome Email Template
      </Typography>

      <Stack spacing={2} sx={{ marginTop: 2 }}>
        <TextField
          label="Email Subject"
          value={subject}
          onChange={(e) => setSubject(e.target.value)}
        />

        <ReactQuill
          value={htmlContent}
          onChange={setHtmlContent}
          style={{ height: '200px', marginBottom: '50px' }}
        />

        <Button variant="contained" onClick={handleSave}>
          Save Template
        </Button>
      </Stack>
    </div>
  );
}
